/**
 * @desc getRoleByCode
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.AppRoleResponseDto>;
export function request(
  params: API.appCenter.appRoleFacadeImpl.getRoleByCode.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/app/role`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
